/**
 * MacroBaby — Carrosséis customizados (vanilla JS, sem dependências).
 * Expõe: window.mbCarousel, window.addCarousel, String.prototype.parsed
 */
String.prototype.parsed = function () {
    return parseInt(this);
};

window.addCarousel = function (selector, opts) {
    let el;
    if (/\:eq/.test(selector)) {
        const idx = parseInt(selector.match(/\beq\((\d+)\)/)[1]);
        const cleanSelector = selector.replace(/\b\:eq\((\d+)\)/, "");
        el = document.querySelectorAll(cleanSelector)[idx];
    } else {
        el = document.querySelector(selector);
    }
    if (!el) return;
    new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) obs.unobserve(entry.target);
        });
    }).observe(el);
};

window.mbCarousel = function (target, options = {}, classes) {
    const root = typeof target === "string" ? document.querySelector(target) : target;
    if (!root) return;

    new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const a = root;
            let r = options;
            const l = classes;

            const alreadyEnabled = a.classList.contains("flickity-enabled");
            const children = Array.from(a.children);
            const container = document.createElement("div");
            const widthCss = getComputedStyle(a).width;
            const isMobile = window.innerWidth <= 800;

            if (alreadyEnabled) { obs.unobserve(entry.target); return; }

            if (Array.isArray(l)) l.forEach(c => a.classList.add(c));
            else if (typeof l === "string") a.classList.add(l);

            if (a.classList.contains("mb-carousel")) { obs.unobserve(entry.target); return; }

            a.classList.add("mb-carousel");

            if (r.responsive) {
                const breakpoints = Object.keys(r.responsive).sort((x, y) => x < y);
                for (let bp of breakpoints) {
                    bp = bp.parsed();
                    if (bp >= window.innerWidth) {
                        const settings = r.responsive[bp.toString()];
                        r = settings.inherit ? Object.assign(r, settings) : settings;
                        break;
                    }
                }
            }

            const itemsPerView = r.items;
            container.classList.add("carousel-container");
            children.forEach(child => {
                const wrap = document.createElement("div");
                wrap.classList.add("carousel-item");
                wrap.append(child);
                container.append(wrap);
            });

            if (itemsPerView) {
                const itemWidth = widthCss.parsed() / itemsPerView;
                children.forEach(child => {
                    child.parentElement.style.width = itemWidth + "px";
                });
            } else {
                children.forEach(child => { child.style.flex = 1; });
            }

            const slideWidth = (r.fullWidth ? getComputedStyle(a) : children[0].parentElement.style).width.parsed();

            const buildEl = (html) => {
                const tmp = document.createElement("div");
                tmp.innerHTML = html;
                return tmp.children[0];
            };

            const scrollBy = (forward) => {
                const left = forward ? container.scrollLeft + slideWidth : container.scrollLeft - slideWidth;
                container.scroll({ top: 0, left, behavior: "smooth" });
            };

            if (children.length > r.items) {
                if (r.dots) {
                    const totalDots = Math.ceil(children.length / itemsPerView);
                    if (totalDots > 1) {
                        const dotsEl = buildEl('\n<ul class="mb-carousel-dots" style="display: none">\n</ul>\n');
                        dotsEl.style.width = (getComputedStyle(a).width.parsed() - 1) + "px";
                        for (let t = 0; t < totalDots; t++) {
                            const dot = buildEl("<li>&nbsp;</li>");
                            dot.addEventListener("click", function () {
                                const active = document.querySelector(".mb-carousel-dots li.active");
                                if (active === this) return;
                                container.scroll({ top: 0, left: slideWidth * t, behavior: "smooth" });
                                active.classList.remove("active");
                                this.classList.add("active");
                            });
                            dotsEl.append(dot);
                        }
                        container.addEventListener("scroll", function () {
                            const idx = Math.ceil(this.scrollLeft / widthCss.parsed());
                            const dots = Array.from(dotsEl.children);
                            const current = dots.find(d => d.classList.contains("active"));
                            const next = dots[idx];
                            if (current !== next) {
                                current.classList.remove("active");
                                next.classList.add("active");
                            }
                        });
                        setTimeout(() => {
                            dotsEl.style.transform = `translateY(${getComputedStyle(a).height})`;
                            dotsEl.style.display = "";
                            dotsEl.children[0].classList.add("active");
                        }, 50);
                        a.append(dotsEl);
                    }
                }

                if (r.buttons) {
                    const btnsEl = buildEl('\n<div class="mb-carousel-buttons" style="display: none">\n<button class="prev"></button>\n<button class="next"></button>\n</div>\n');
                    btnsEl.children[0].addEventListener("click", () => scrollBy(false));
                    btnsEl.children[1].addEventListener("click", () => scrollBy(true));
                    btnsEl.style.width = (getComputedStyle(a).width.parsed() - 1) + "px";
                    setTimeout(() => {
                        btnsEl.style.transform = `translateY(${getComputedStyle(a).height.parsed() / 2 - 25}px)`;
                        btnsEl.style.display = "";
                        btnsEl.children[0].classList.add("disappear");
                        container.addEventListener("scroll", function () {
                            const left = this.scrollLeft;
                            const atEnd = container.scrollLeft === container.scrollWidth - container.clientWidth;
                            if (left === 0) btnsEl.children[0].classList.add("disappear");
                            else if (atEnd) btnsEl.children[1].classList.add("disappear");
                            else btnsEl.querySelectorAll("button").forEach(b => b.classList.remove("disappear"));
                        });
                    });
                    a.append(btnsEl);
                }

                if (isMobile) {
                    const snap = (val, step) => {
                        const rem = val % step;
                        return rem <= step / 2 ? val - rem : val + step - rem;
                    };
                    container.addEventListener("touchend", function () {
                        const left = snap(this.scrollLeft, slideWidth);
                        container.scroll({ top: 0, left, behavior: "smooth" });
                    });
                }
            }

            a.append(container);
            a.classList.add("active");
            obs.unobserve(entry.target);
        });
    }).observe(root);
};
